import Vue from 'vue'
import Router from 'vue-router'
import vuexStore from '@/store'
import { SET_WX_JS_URL, SET_NAVIGATION_TITLE } from '@/store/mutation-types'
import { saveInviterUnionID, isWeiXin } from '@/utils/help'
import Consts from '@/common/consts'
import Cookie from '@/utils/cookie'
import LocalStore from '@/utils/localStore'
import CommonRouter from '@/router/common'
import UserRouter from '@/router/user'
import TbkRouter from '@/router/tbk'
import PddRouter from '@/router/pdd'
import JdRouter from '@/router/jd'
import VphRouter from '@/router/vph'

Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
const routes = new Set([...CommonRouter, ...UserRouter, ...TbkRouter, ...PddRouter, ...JdRouter, ...VphRouter]) // 合并多个路由
const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.meta.isTab) {
    document.title = to.meta.title
  } else {
    if (!isWeiXin()) {
      document.title = to.meta.title || 'DSHUI领券专区'
    } else {
      document.title = 'DSHUI领券专区'
    }
  }
  saveInviterUnionID(to.query) // 保存推荐人的邀请码
  // 维护一个路由栈(剔除重复路由,压栈方式加入, 如果手动F5刷新则路由栈清空)
  let routerStack = LocalStore.get(Consts.STORE_ROUTE_STACK, []) // 路由栈
  if (!from.name && to.name) {
    // 初次加载
    const homeRouteArr = [ 'home', 'pddHome', 'jdHome', 'vphHome' ]
    const fromSourceArr = [ 'shop_h5' ]
    const homeRouteMap = { home: '淘宝热卖', pddHome: '拼多多热卖', jdHome: '京东热卖', vphHome: '唯品会热卖' }
    if (homeRouteArr.indexOf(to.name) > -1 && to.query.from_source && fromSourceArr.indexOf(to.query.from_source) > -1) {
      // 需要显示顶部返回商城的导航栏
      vuexStore.commit(SET_NAVIGATION_TITLE, { title: homeRouteMap[to.name], fromSourceUrl: to.query.from_source_url || `https://m.${Consts.WAP_HOST}` })
    }
    routerStack = []
    routerStack.unshift({ name: to.name, query: to.query, params: to.params, fullPath: to.fullPath })
  } else {
    for (let i = 0; i < routerStack.length; i++) {
      if (routerStack[i].name === to.name) {
        routerStack.splice(i, 1)
      }
    }
    routerStack.unshift({ name: to.name, query: to.query, params: to.params, fullPath: to.fullPath })
  }
  LocalStore.set(Consts.STORE_ROUTE_STACK, routerStack)
  if (to.matched.some(r => r.meta.requireAuth)) {
    // 判断该路由的访问是否需要登录
    let token = Cookie.get(Consts.COOKIE_USER_TOKEN)
    let mobile = Cookie.get(Consts.COOKIE_USER_MOBILE)
    let pwd = Cookie.get(Consts.COOKIE_USER_MD5_PWD)
    if (token || (mobile && pwd)) {
      next()
    } else {
      next({ name: 'login', query: { target: encodeURIComponent(to.fullPath) } })
    }
  } else {
    next()
  }
})

router.afterEach(function(to) {
  if (!vuexStore.state.jsUrl) {
    // 记录第一次进入的URL,解决路由在开启history模式下,在IOS微信浏览器中调用微信分享jsSdk的问题
    vuexStore.commit(SET_WX_JS_URL, document.URL)
  }
})

export default router
